import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { FullScreenLoader } from "../../components/ui/loaders/full-screen-loader.js";
import { subscriptionGet } from "../../services/api.service.js";
import { FailedToCheckSubscription } from "./failed-to-check-subscription.js";
import { SubscriptionContext } from "./subscription.context.js";
import type { SubscriptionContextType } from "./subscription.context.js";

export const SubscriptionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data, isLoading, error } = useQuery({
    queryFn: subscriptionGet,
    queryKey: ["getMySubscription"],
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
  });

  const value = useMemo<SubscriptionContextType>(
    () => ({
      __ctx_init: Boolean(data),
      features: data?.features ?? [],
      planId: data?.planId ?? null,
      source: data?.source ?? "none",
      status: data?.status ?? "inactive",
      trialExpiresAt: data?.meta?.trialExpiresAt
        ? new Date(data.meta.trialExpiresAt)
        : null,
    }),
    [data]
  );

  if (isLoading) {
    return <FullScreenLoader message="Checking subscription" />;
  }

  // TODO: Check for error, otherwise allow access
  if (error || !data) {
    return <FailedToCheckSubscription />;
  }

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};
